import ToastList from "@shared/componets/feedback/ToastList/ToastList";
import React, { createContext, useState } from "react";
const ToastContext = createContext();

function ToastProvider({ children }) {
    const [toasts, setToasts] = useState([]);

    function newToast(message, color = 'success', timeOut = 5000, id = 'id') {
        const date = Date.now();
        const newToast = {
            id: `${date}-${id}`,
            message,
            color,
            timeOut
        };
        setToasts((t) => [...t, newToast]);
        return id;
    };

    function clearToast(toast_id) {
        setToasts((t) => t.filter((toast) => toast.id !== toast_id));
    };

    const value = {
        newToast,
        toasts,
        clearToast,
    };

    return (
        <ToastContext.Provider value={value}>{children}
            <ToastList />
        </ToastContext.Provider>
    );
};

export { ToastContext, ToastProvider };
